import React from 'react'

type NavigationMenuContextType = {
  isNavigationMenuOpen: boolean
  navigationHeight: number
  navigationMenuValue: string
  offsetHeight: number
  isAccountMenuOpen: boolean
  setIsNavigationMenuOpen: (open: boolean) => void
  setNavigationHeight: (height: number) => void
  setNavigationMenuValue: (value: string) => void
  setOffsetHeight: (height: number) => void
  setIsAccountMenuOpen: (open: boolean) => void
}

export const NavigationMenuContext =
  React.createContext<NavigationMenuContextType>({
    isNavigationMenuOpen: false,
    navigationMenuValue: '',
    navigationHeight: 0,
    offsetHeight: 0,
    isAccountMenuOpen: false,
    setIsNavigationMenuOpen: () => {},
    setNavigationHeight: () => {},
    setNavigationMenuValue: () => {},
    setOffsetHeight: () => {},
    setIsAccountMenuOpen: () => {},
  })
